<div class="d-flex flex-column h-100">
  <mat-drawer-container autosize class="h-100">
    <mat-drawer class="navbar expanded"
                mode="side"
                opened>
      <app-left-menu
        *ngIf="(userLogin$ | async) as userLogin"
        [sideNav]="sideNav"
        [user]="userLogin">
      </app-left-menu>
    </mat-drawer>
    <mat-drawer-content class="p-4" style="background-color: #fff">
      <div class="d-flex flex-column h-100 gap-2">
        <div *ngIf="(userLogin$ | async) as userLogin" class="d-flex justify-content-between align-items-center">
          <div>
            <h2 class="greeting-title">Hello, {{userLogin.fullName}}</h2>
            <p>{{supportingText()}}</p>
          </div>
          <div *ngIf="userLogin.companies.length > 0">
            <mat-form-field appearance="outline">
              <mat-label>Selected Company</mat-label>
              <mat-select (valueChange)="onChangeCompany($event)" [value]="(activeCompanyCode$ | async)">
                <mat-option *ngFor="let company of userLogin.companies"
                            [value]="company.companyCode">{{company.companyName ? company.companyName : company.companyCode}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <router-outlet></router-outlet>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>
</div>
